import CommandesApi from '@/api/commandes';
import StoreBuilder from '../store-builder';
import { min, addDays, format, parseISO, addMonths, isBefore } from 'date-fns';

const builder = new StoreBuilder('commandes');

builder.addStatePart('historiqueLivraisons', null, (numTiers) => CommandesApi.getHistoriqueLivraisons(numTiers));

builder.setActions({
  loadSuiteHistoriqueLivraisons ({ commit, state }, numTiers) {
    const plusAncienneDate = state.historiqueLivraisons.map(ligne => parseISO(ligne.dateEffectiveLivraison)).reduce((dateMin, date) => min([date, dateMin]), Date.now());
    return CommandesApi.getHistoriqueLivraisons(numTiers, format(addDays(plusAncienneDate, -1), 'yyy-MM-dd')).then(lignes => {
      commit('ADD_LIVRAISONS', lignes);
      return lignes;
    });
  },

  envoyerCommande ({ dispatch }, { numTiers, commande }) {
    return CommandesApi.envoyerCommande(numTiers, commande);
  }
});

builder.setMutations({
  ADD_LIVRAISONS (state, lignes) {
    state.historiqueLivraisons = state.historiqueLivraisons.concat(lignes);
  }
});

const NB_MONTH_LOAD_HISTORIQUE = 3;
function loadHistoriqueCommandes (numTiers, dateDebut, dateFin) {
  dateFin = dateFin || Date.now();
  dateDebut = dateDebut || addMonths(dateFin, -NB_MONTH_LOAD_HISTORIQUE);

  return CommandesApi.getCommandes(numTiers, ['FACTUREE', 'ERREUR', 'SUPPRIMEE'], format(dateDebut, 'yyyy-MM-dd'), format(dateFin, 'yyyy-MM-dd')).then(
    (commandes) => {
      if (commandes.length === 0) {
        if (!isBefore(dateDebut, parseISO('2020-11-01'))) {
          return loadHistoriqueCommandes(numTiers, addMonths(dateDebut, -NB_MONTH_LOAD_HISTORIQUE), addDays(dateDebut, -1));
        }
      }

      Object.defineProperty(commandes, '__dateDebut', { configurable: true, enumerable: false, value: dateDebut });

      return commandes;
    }
  );
}

builder.addStatePart('commandesEnCours', null, (numTiers) => CommandesApi.getCommandes(numTiers, ['ENREGISTREE', 'PREPAREE', 'VALORISEE', 'LOGISTIQUE', 'LIVREE']));
builder.addStatePart('historiqueCommandes', null, (numTiers) => loadHistoriqueCommandes(numTiers));

builder.setMutations({
  ADD_COMMANDES (state, commandes) {
    state.historiqueCommandes = state.historiqueCommandes.concat(commandes);
    state.historiqueCommandes.__dateDebut = commandes.__dateDebut;
  }
});

builder.setActions({
  loadSuiteHistoriqueCommandes ({ commit, state }, numTiers) {
    const previousDate = state.historiqueCommandes.__dateDebut;

    return loadHistoriqueCommandes(numTiers, addMonths(previousDate, -NB_MONTH_LOAD_HISTORIQUE), addDays(previousDate, -1)).then(
      commandes => {
        commit('ADD_COMMANDES', commandes);
        return commandes;
      }
    );
  }
});

export default builder.build();
